import { getPackages } from 'MediaManager/services/packages'
import React, { useCallback, useMemo } from 'react'
import Button from 'shared/components/Button'
import Loader from 'shared/components/Loader'
import TinyModal from 'shared/components/TinyModal'
import { useRequest } from 'shared/hooks/useRequest'

function Popup({ vendorId, onClose, onPicked }) {
  const getPackagesRequest = useCallback(async () => {
    const { data } = await getPackages()
    return data.packages
  }, [])

  const { data, loading } = useRequest(getPackagesRequest)

  const packages = useMemo(() => {
    if (data && vendorId) {
      const packs = data
        ?.filter((p) => p.vendor?.id === vendorId && (p.package_type === 'csv' || !p.package_type))
        .map(({ name, id, package_type }) => ({
          name,
          id,
          package_type
        }))
        return packs
    }
    return []
  }, [data, vendorId])

  return (
    <TinyModal closeIcon onClose={onClose} title="Select package" className="lg:!w-max">
      {loading && (
        <div className="flex justify-center min-w-[200px] ">
          {' '}
          <Loader />
        </div>
      )}
      {packages.length === 0 && !loading && (
        <div className="opacity-50 text-center">There is no packages available for selected vendor</div>
      )}
      {packages.length > 0 && !loading && (
        <div className="max-h-[80dvh] overflow-y-auto">
          {packages.map((o, index) => (
            <Button
              className="mt-[16px]"
              rounded
              onClick={() => {
                onPicked(o)
              }}
            >
              ({o.id}) {o.name}
            </Button>
          ))}
        </div>
      )}
    </TinyModal>
  )
}

function SelectPackage({ vendorId, pack, onPicked }) {
  const [popupShown, setPopupShown] = React.useState(false)

  return (
    <>
      {!pack && (
        <Button disabled={!vendorId} rounded size="small" onClick={() => setPopupShown(true)}>
          Select package
        </Button>
      )}
      {pack && (
        <Button
          rounded
          variant="secondary"
          size="small"
          onClick={() => {
            if (window.confirm('Are you sure you want to remove this package?')) {
              onPicked(null)
            }
          }}
        >
          Remove package
        </Button>
      )}
      {popupShown && (
        <Popup
          onClose={() => {
            setPopupShown(false)
          }}
          onPicked={(pack) => {
            onPicked(pack)
            setPopupShown(false)
          }}
          vendorId={vendorId}
        />
      )}
    </>
  )
}

export default SelectPackage
